import { render, staticRenderFns } from "./DoctorPageLpuListHeader.vue?vue&type=template&id=51370a66&scoped=true&"
import script from "./DoctorPageLpuListHeader.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorPageLpuListHeader.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DoctorPageLpuListHeader.vue?vue&type=style&index=0&id=51370a66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51370a66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51370a66')) {
      api.createRecord('51370a66', component.options)
    } else {
      api.reload('51370a66', component.options)
    }
    module.hot.accept("./DoctorPageLpuListHeader.vue?vue&type=template&id=51370a66&scoped=true&", function () {
      api.rerender('51370a66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPageLpuList/components/DoctorPageLpuListHeader.vue"
export default component.exports